// extracted by mini-css-extract-plugin
export default {"CustomerListItemContainer":"style_CustomerListItemContainer__mnNwk","namePhoneContainer":"style_namePhoneContainer__u-WMJ"};